export default __webpack_public_path__ + "static/media/attisBackground.57fd2867.jpg";